/** Hàm thuần của phần chia nhiều cách trả (KH-GĐ2 5.1) — tách khỏi component để test không cần trình duyệt. */
import type { HinhThucThu } from './api.ts'

export const CAC_CACH: HinhThucThu[] = ['cash', 'transfer', 'card']

export type ChiaTien = Record<HinhThucThu, string>
export const CHIA_RONG: ChiaTien = { cash: '', transfer: '', card: '' }

/** Các phần > 0 của bảng chia (chuỗi đồng) — gửi máy chủ. */
export function cacPhanChia(chia: ChiaTien): { hinhThuc: HinhThucThu; soTienVnd: string }[] {
  return CAC_CACH.filter((h) => chia[h] !== '' && BigInt(chia[h]) > 0n).map((h) => ({
    hinhThuc: h,
    soTienVnd: chia[h],
  }))
}

export function tongChia(chia: ChiaTien): bigint {
  return cacPhanChia(chia).reduce((t, p) => t + BigInt(p.soTienVnd), 0n)
}

/** Chia hợp lệ khi tổng = phần phải thu và mọi phần chẵn nghìn. */
export function chiaHopLe(chia: ChiaTien, phaiThu: bigint): boolean {
  const cac = cacPhanChia(chia)
  return (
    cac.length >= 1 &&
    cac.every((p) => BigInt(p.soTienVnd) % 1000n === 0n) &&
    tongChia(chia) === phaiThu
  )
}
